import Sidebar from "components/sidebar";
import { Box } from "@mui/material";
import Header from "components/header";
import SettingsContainer from "components/Settings/SettingsContainer";

const Settings = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '100vw' }}>
                <Header />
                <SettingsContainer />
            </Box>
        </Box>
    )
}

export default Settings;